/** Setores da atividade*/
export interface AtividadeFilterVisibilidade {
    id: number;
    nome: string;
    iconClass: string;
}

export const visibilidadeMinhas: AtividadeFilterVisibilidade = {id: 1, nome: 'Minhas Atividades', iconClass: 'far fa-user'};
export const visibilidadeCriadasPorMim: AtividadeFilterVisibilidade = {id: 2, nome: 'Criadas por mim', iconClass: 'fas fa-people-arrows'};
export const visibilidadeTodas: AtividadeFilterVisibilidade = {id: 3, nome: 'Todas Atividades', iconClass: 'fas fa-users'};

export const visibilidades: AtividadeFilterVisibilidade[] = [
    visibilidadeMinhas,
    visibilidadeCriadasPorMim,
    visibilidadeTodas
];

/** Verifica se o filtro da visibilidade das atividades é Minhas */
export function isVisibilidadeMinhas(id: number): boolean {
    return id === visibilidadeMinhas.id;
}


/** Verifica se o filtro da visibilidade das atividades é Criadas por mim */
export function isVisibilidadeCriadasPorMim(id: number): boolean {
    return id === visibilidadeCriadasPorMim.id;
}

/** Verifica se o filtro da visibilidade das atividades é Todas */
export function isVisibilidadeTodas(id: number): boolean {
    return id === visibilidadeTodas.id;
}
